import {
  COMANAGER_HEIGHT,
  enumChartElement,
  enumChartRenderOrder,
  enumDropType,
  enumElementDrawStates,
  enumSCArrowVariants,
  enumSubChartFlag,
  kSCArrowOffset
} from "../constants";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { Div2Floor } from "../utils/Div2Floor";
import { GetSCArrowHeight } from "../utils/GetSCArrowHeight";
import { GetSCArrowWidth } from "../utils/GetSCArrowWidth";
import { XML_DrawLargeSubchartArrow } from "../utils/XML_DrawLargeSubchartArrow";
import { XML_DrawSmallSubchartArrow } from "../utils/XML_DrawSmallSubchartArrow";
import { QElement } from "./QElement";
import { Globals } from "./Globals";

export class QSubChartArrow extends QElement {
  constructor() {
    super();
    this.fChartBox = null;
    this.fVariant = null;

    this.fArrowHeight = null;
    this.fArrowWidth = null;
    this.fInverted = null;
  }

  InitSubChartArrow(chartBox, isInverted) {
    this.fChartBox = chartBox;
    this.fInverted = isInverted;
    this.SetZPlane(enumChartRenderOrder.overlay);
    this.SetLayer(chartBox.GetLayer());
    this.SetCmdCode("DrillSubChart");
    this.SetElementType(enumChartElement.scArrow);
  }

  GetHitBox() {
    var rightLeftThreshold = 25;
    var bottomTopThreshold = kSCArrowOffset;
    if (Globals._mobileDevice) {
      var sf = Globals._wsMgr.fCanvasPanel.GetScaleFactor();
      rightLeftThreshold = Math.floor(40 / sf);
      bottomTopThreshold = Math.floor(kSCArrowOffset / sf);
    }
    return this.CreateBoundingHitBox(
      rightLeftThreshold,
      rightLeftThreshold,
      bottomTopThreshold,
      bottomTopThreshold
    );
  }

  GetWidth(pub) {
    return GetSCArrowWidth(this.fVariant, pub);
  }

  GetHeight(pub) {
    return GetSCArrowHeight(this.fVariant, pub);
  }

  GetAssociatedBox() {
    return this.fChartBox;
  }

  GetPositionX(pub) {
    var xPos =
      this.fChartBox.GetPositionX() +
      Math.round(this.fChartBox.GetWidth() / 2) -
      Math.round(this.GetWidth(pub) / 2);
    return xPos;
  }

  GetPositionY(pub) {
    var arrowDown = this.fInverted
      ? this.fChartBox.GetSubChartFlag() == enumSubChartFlag.drillup
      : this.fChartBox.GetSubChartFlag() == enumSubChartFlag.drilldown;

    var borderStyle = this.fChartBox.GetBorderStyle();
    var borderThickness = this.fChartBox.GetAdjBorderThickness();

    var yPos;
    if (arrowDown) {
      yPos =
        this.fChartBox.GetPositionY() +
        this.fChartBox.GetHeight() +
        kSCArrowOffset +
        borderStyle * borderThickness;
      if (this.fChartBox.NeedsExtraBottomSpace()) {
        yPos += COMANAGER_HEIGHT + 1;
      }
    } else {
      yPos =
        this.fChartBox.GetPositionY() -
        kSCArrowOffset -
        borderStyle * borderThickness -
        this.GetHeight(pub);
    }

    return yPos;
  }

  IsShown() {
    //if (this.fChartBox) return !this.fChartBox.GetContainerNode();
    return true;
  }

  GetCursor() {
    if (this.fChartBox.IsDrillActive()) return "pointer";

    return null;
  }

  DropTypeTest() {
    return this.fChartBox.GetSubChartFlag() == enumSubChartFlag.drilldown
      ? enumDropType.drillunder
      : enumDropType.drillup;
  }

  DoRenderElement(drawBuffer) {
    switch (Globals._scArrowStyle) {
      case enumSCArrowVariants.blackarrow:
        this.DoRenderLargeArrow(drawBuffer, true, null);
        break;
      case enumSCArrowVariants.whitearrow:
        this.DoRenderLargeArrow(drawBuffer, false, null);
        break;
      case enumSCArrowVariants.miniarrow:
      case enumSCArrowVariants.themearrow:
        this.DoRenderSmallArrow(drawBuffer, null, null);
        break;
    }
  }

  RenderSelectionHighlight(drawBuffer) {
    //Overridden.
  }

  RenderLargeArrow(x, y, shaftW, shaftH, headH, headW, drawBuffer, blackFill, altCanvasElement) {
    var halfShaftW = Div2Floor(shaftW / 2);
    var halfHeadW = Div2Floor(headW / 2);
    var thickAdj = 1;
    var sy = y;
    var mx = x;
    var upFlag = false;
    var chartBox = this.fChartBox;
    if (chartBox) {
      upFlag = this.fInverted
        ? chartBox.GetSubChartFlag() === enumSubChartFlag.drilldown
        : chartBox.GetSubChartFlag() === enumSubChartFlag.drillup;
      if (upFlag) {
        sy = sy + shaftH + headH;
        shaftH = -shaftH;
        headH = -headH;
      }
    }

    var style = this.DrawStyles(blackFill);

    var x0 = mx - halfShaftW - thickAdj;
    var x1 = mx - halfHeadW - thickAdj;
    var x2 = mx;
    var x3 = mx + halfHeadW + thickAdj;
    var x4 = mx + halfShaftW + thickAdj;
    var y0 = sy;
    var y1 = sy + shaftH;
    var y2 = sy + shaftH + headH;

    if (drawBuffer != null) {
      var vertexes = this.ArrowVertexes("LargeArrowType", upFlag);
      var ctx = drawBuffer.getContext("2d");
      ctx.strokeStyle = style.buttonStroke;
      ctx.fillStyle = style.buttonFill;
      ctx.lineWidth = 2;
      ctx.lineJoin = "miter";
      ctx.beginPath();
      ctx.moveTo(x + vertexes[0].x, y + vertexes[0].y);
      for (var i = 1; i < vertexes.length; i++) {
        ctx.lineTo(x + vertexes[i].x, y + vertexes[i].y);
      }
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
    } else {
      var linkBookmark = chartBox.GetLinkBookmark();
      var layer = this.GetLayer();
      XML_DrawLargeSubchartArrow(
        x0,
        x1,
        x2,
        x3,
        x4,
        y0,
        y1,
        y2,
        style.buttonFill,
        altCanvasElement,
        linkBookmark,
        layer
      );
    }
  }

  DoRenderLargeArrow(drawBuffer, blackFill, altCanvasElement) {
    var ar = this.GetWidth(altCanvasElement);
    var ah = this.GetHeight(altCanvasElement);
    var sx = this.GetPositionX(altCanvasElement);
    var sy = this.GetPositionY(altCanvasElement);
    var mx = sx + Div2Floor(ar);
    var shaftW = ar;
    var shaftH = Div2Floor(ah);
    var headH = Div2Floor(ar);
    var headW = ar * 2;

    this.RenderLargeArrow(
      mx,
      sy,
      shaftW,
      shaftH,
      headH,
      headW,
      drawBuffer,
      blackFill,
      altCanvasElement
    );
  }

  DoRenderSmallArrow(drawBuffer, altCanvasElement) {
    var sx = this.GetPositionX(altCanvasElement);
    var ya = this.GetPositionY(altCanvasElement);
    var ar = this.GetWidth(altCanvasElement);
    var ah = this.GetHeight(altCanvasElement);
    var mx = sx + Div2Floor(ar);
    var ex = sx + ar;
    var yb = ya + ah;

    var sy, ey;
    sy = ya;
    ey = yb;
    var upFlag = false;
    var chartBox = this.fChartBox;
    if (chartBox) {
      upFlag = this.fInverted
        ? chartBox.GetSubChartFlag() === enumSubChartFlag.drilldown
        : chartBox.GetSubChartFlag() === enumSubChartFlag.drillup;
      if (upFlag) {
        sy = yb;
        ey = ya;
      }
    }

    var style = this.DrawStyles(true);

    var t0x, t0y, t1x, t1y, t2x, t2y;
    t0x = sx;
    t0y = sy;
    t1x = ex;
    t1y = sy;
    t2x = sx + Div2Floor(ar);
    t2y = ey;

    if (drawBuffer != null) {
      var vertexes = this.ArrowVertexes("SmallArrowType", upFlag);
      var ctx = drawBuffer.getContext("2d");
      ctx.strokeStyle = style.buttonStroke;
      ctx.fillStyle = style.buttonFill;
      ctx.lineWidth = 1.5;
      ctx.lineJoin = "miter";
      ctx.beginPath();
      ctx.moveTo(mx + vertexes[0].x, ya + vertexes[0].y);
      for (var i = 1; i < vertexes.length; i++) {
        ctx.lineTo(mx + vertexes[i].x, ya + vertexes[i].y);
      }
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
    } else {
      var linkBookmark = chartBox.GetLinkBookmark();
      var layer = this.GetLayer();
      XML_DrawSmallSubchartArrow(
        t0x,
        t0y,
        t1x,
        t1y,
        t2x,
        t2y,
        altCanvasElement,
        linkBookmark,
        layer,
        style
      );
    }
  }

  DrawStyles(blackFill) {
    var style = {
      buttonFill: blackFill ? "#000000" : "#FFFFFF",
      buttonStroke: blackFill ? "#FFFFFF" : "#000000"
    };

    if (
      this.fVariant == enumSCArrowVariants.themearrow ||
      (this.fVariant == null && Globals._scArrowStyle == enumSCArrowVariants.themearrow)
    ) {
      style.buttonFill = uFramelessPanelColor;
      style.buttonStroke = DetermineTextColor(uFramelessPanelColor);
    }

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        break;
      case enumElementDrawStates.Hover:
        style.buttonFill = "#F4DA5A";
        break;
      case enumElementDrawStates.MouseDown:
        style.buttonFill = "#F49020";
        style.buttonStroke = "#FFFFFF";
        break;
      case enumElementDrawStates.Disabled:
        style.buttonStroke = "#AFAFAF";
        break;
    }
    if (this.fSelected) {
      style.buttonFill = "#00FF00";
    }

    return style;
  }

  ArrowVertexes(arrowType, flipped) {
    var halfWidth = Math.round(this.GetWidth() / 2);
    var height = Math.round(this.GetHeight());

    if (arrowType == "LargeArrowType") {
      var vertexes = [
        { x: -Math.round(halfWidth / 2) - 1, y: 0 },
        { x: -Math.round(halfWidth / 2) - 1, y: Math.round(height / 2) - 1 },
        { x: -(halfWidth + 1), y: Math.round(height / 2) - 1 },
        { x: 0, y: height },
        { x: halfWidth + 1, y: Math.round(height / 2) - 1 },
        { x: Math.round(halfWidth / 2) + 1, y: Math.round(height / 2) - 1 },
        { x: Math.round(halfWidth / 2) + 1, y: 0 }
      ];
    }

    if (arrowType == "SmallArrowType") {
      var vertexes = [
        { x: -halfWidth, y: 0 },
        { x: 0, y: height },
        { x: halfWidth, y: 0 }
      ];
    }

    if (flipped) {
      for (var i = 0; i < vertexes.length; i++) {
        vertexes[i].x = -vertexes[i].x;
        vertexes[i].y = height - vertexes[i].y;
      }
    }

    return vertexes;
  }

  ObjectName() {
    return "QSubChartArrow";
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();

    switch (altCanvasType) {
      case "SVG":
        break;
      case "XML":
        this.DoXMLRenderArrow(altCanvas);
        break;
    }
  }

  DoXMLRenderArrow(altCanvas) {
    var altCanvasElement = altCanvas.GetCanvasElement();

    switch (Globals._scArrowStyle) {
      case enumSCArrowVariants.blackarrow:
        this.DoRenderLargeArrow(null, true, altCanvasElement);
        break;
      case enumSCArrowVariants.whitearrow:
        this.DoRenderLargeArrow(null, false, altCanvasElement);
        break;
      case enumSCArrowVariants.miniarrow:
      case enumSCArrowVariants.themearrow:
        this.DoRenderSmallArrow(null, altCanvasElement);
        break;
    }
  }
}
